import API from 'fw/system/API'

export const Certification = new API("NVBDC.Certification", process.env.REACT_APP_CORE_API_URL + "/certification");
export const Biz = new API("NVBDC.Biz", process.env.REACT_APP_CORE_API_URL + "/biz");
export const App = new API("NVBDC.App", process.env.REACT_APP_CORE_API_URL + "/app");
export const Security = new API("NVBDC.Security", process.env.REACT_APP_CORE_API_URL + "/security");
export const Admin = new API("NVBDC.Admin", process.env.REACT_APP_CORE_API_URL + "/admin");
export const Sponsor = new API("NVBDC.Sponsor", process.env.REACT_APP_CORE_API_URL + "/sponsor");
export const DiscountCode = new API("NVBDC.DiscountCode", process.env.REACT_APP_CORE_API_URL + "/discountCode");
export const Job = new API("NVBDC.Job", process.env.REACT_APP_CORE_API_URL + "/job");

export const Core = new API("NVBDC.Core", process.env.REACT_APP_CORE_API_URL);
export const Emailing  = new API("NVBDC.Emailing", process.env.REACT_APP_EMAILING_API_URL);
export const Audit = new API("NVBDC.Audit", process.env.REACT_APP_AUDIT_API_URL);
export const Reporting  = new API("NVBDC.Reporting", process.env.REACT_APP_REPORTING_API_URL);
export const Import  = new API("NVBDC.Import", process.env.REACT_APP_IMPORT_API_URL);
export const Search  = new API("NVBDC.Search", process.env.REACT_APP_SEARCH_API_URL);



// WEBPACK FOOTER //
// ./src/modules/app/API.js